/**
 * ------ maintenance history ------
 */
import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { TamDashboardActions, TileMode, TamDashboardEvents } from '../tam-dashboard.model';
import { TamDashboardTileBaseComponent } from '../tam-dashboard-tile.base.component';
import { TamDashboardRichTextTileConfiguration } from './tam-dashboard-rich-text-tile.config';
declare let $: any;

@Component({
    selector: 'tam-dashboard-rich-text-tile',
    templateUrl: './tam-dashboard-rich-text-tile.component.html',
    styleUrls: ['./tam-dashboard-rich-text-tile.component.scss']
})
export class TamDashboardRichTextTileComponent implements OnInit, AfterViewInit, OnDestroy, TamDashboardTileBaseComponent {

    config: TamDashboardRichTextTileConfiguration;
    // handle display undefined
    data: any = { html: '' };
    isLoading = false;
    mode: TileMode = 0;
    options: object;

    private _editor: any = null;
    private _afterViewFeedback$ = new Subject<string>();
    private _destroySubscriptions: Array<Subscription> = [];

    constructor() {
        const _this = this;
        this.options = {
            key: 'XAG4eH3A3A6A7C5B5C-11VKOJ1FGULVKHXDXNDXc1d1Kg1SNdD5B4A4D4H3I3G3B7A4C3==',
            charCounterCount: false,
            toolbarInline: true,
            toolbarButtons: {
                'moreText': {
                    'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'fontFamily',
                        'fontSize', 'textColor', 'backgroundColor', 'clearFormatting',
                        'paragraphFormat', 'align', 'outdent',
                        'indent', 'insertLink', 'formatUL', 'formatOL', 'quote',
                        'insertImage', 'insertTable', 'fontAwesome',
                        'insertHR', 'undo', 'redo',
                        'lineHeight', 'subscript', 'superscript', 'specialCharacters'],
                    'buttonsVisible': 22
                },
            },
            toolbarVisibleWithoutSelection: true,
            imageInsertButtons: ['imageUpload', 'imageBack'],
            fontFamilyDefaultSelection: 'Font',
            quickInsertButtons: ['image', 'table', 'ul', 'ol', 'hr'],
            imageUploadRemoteUrls: false,
            fontSizeSelection: true,
            fontSizeUnit: 'pt',
            fontSizeDefaultSelection: '11pt',
            useClasses: false,
            pasteAllowLocalImages: true,
            pastePlain: false,
            pluginEnabled: ['customPlugin'],
            spellcheck: true,
            height: '100%',
            imageDefaultWidth: 0,
            imageDefaultAlign: 'left',
            linkAlwaysBlank: true,
            htmlUntouched: true,
            events: {
                'image.beforePasteUpload': function (files) {
                    const editor = this;
                    if (files.length) {
                        // Create a File Reader.
                        const reader = new FileReader();
                        // Set the reader to insert images when they are loaded.
                        reader.onload = function (e) {
                            const result = reader.result;
                            editor.image.insert(result, null, null, editor.image.get());
                        };
                        // Read image as base64.
                        reader.readAsDataURL(files[0]);
                    }
                    editor.popups.hideAll();
                    return false;
                },
                'image.beforeUpload': function (files) {
                    const editor = this;
                    if (files.length) {
                        // Create a File Reader.
                        const reader = new FileReader();
                        // Set the reader to insert images when they are loaded.
                        reader.onload = function (e) {
                            const result = reader.result;
                            editor.image.insert(result, null, null, editor.image.get());
                        };
                        // Read image as base64.
                        reader.readAsDataURL(files[0]);
                    }
                    editor.popups.hideAll();
                    // Stop default upload chain.
                    return false;
                },
                'blur': function (e, editor) {
                    _this.onChange(e);
                    _this.mode = TileMode.READ;
                }
            },
            fontFamily: {
                'Arial,Helvetica,sans-serif': 'Arial',
                'Calibri-Regular': 'Calibri',
                'Georgia,serif': 'Georgia', 'Impact,Charcoal,sans-serif': 'Impact',
                'OpenSans-Regular': 'OpenSans',
                'Tahoma,Geneva,sans-serif': 'Tahoma',
                '\'Times New Roman\',Times,serif': 'Times New Roman',
                'Roboto-Regular': 'Roboto',
                'SourceSansPro-Regular': 'SourceSansPro',
                'Verdana,Geneva,sans-serif': 'Verdana',
            },
            lineHeights: {
                Default: '',
                Single: '1',
                '1.5': '1.5',
                Double: '2'
            },
        };
    }

    ngOnInit() {

    }

    ngAfterViewInit(): void {
        this._afterViewFeedback$.next(TamDashboardEvents.TILE_AFTER_VIEW_INIT);
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(element => element.unsubscribe());
        if (this.config) {
            this.config.destroy();
        }
    }

    initFroalaEditor() {
        // Define popup template.

        $.FroalaEditor.POPUP_TEMPLATES['customPlugin.popup'] = '[_BUTTONS_]';
        // Define popup buttons.
        Object.assign($.FroalaEditor.DEFAULTS, {
            popupButtons: ['strikeThrough', 'subscript', 'superscript', 'paragraphFormat', 'lineHeight', '|  ', 'align', 'outdent', 'indent', 'formatUL', 'formatOL', 'quote', 'fontAwesome', 'specialCharacters', 'insertHR'],
        });

        // The custom popup is defined inside a plugin (new or existing).
        $.FroalaEditor.PLUGINS.customPlugin = function (editor) {
            // Create custom popup.
            function initPopup() {
                // Popup buttons.
                let popup_buttons = '';

                // Create the list of buttons.
                if (editor.opts.popupButtons.length > 1) {
                    popup_buttons += '<div class="fr-buttons">';
                    popup_buttons += editor.button.buildList(editor.opts.popupButtons);
                    popup_buttons += '</div>';
                }

                // Load popup template.
                const template = {
                    buttons: popup_buttons,
                    // custom_layer: '<div class="custom-layer">Hello World!</div>'
                };

                // Create popup.
                const $popup = editor.popups.create('customPlugin.popup', template);

                return $popup;
            }

            // Show the popup
            function showPopup() {
                // following line won't workd: popup will be shown at wrong place.
                // var $popup = editor.popups.get('customPlugin.popup');
                // if (!$popup) $popup = initPopup();
                initPopup();

                // Set the editor toolbar as the popup's container.
                editor.popups.setContainer('customPlugin.popup', editor.$tb);

                // This will trigger the refresh event assigned to the popup.
                // editor.popups.refresh('customPlugin.popup');

                // This custom popup is opened by pressing a button from the editor's toolbar.
                // Get the button's object in order to place the popup relative to it.
                const $btn = editor.$tb.find('.fr-command[data-cmd="moreButtons"]');

                // Set the popup's position.
                const left = $btn.offset().left + $btn.outerWidth() / 2;
                const top = $btn.offset().top + (editor.opts.toolbarBottom ? 10 : $btn.outerHeight() - 10);

                // Show the custom popup.
                // The button's outerHeight is required in case the popup needs to be displayed above it.
                editor.popups.show('customPlugin.popup', left, top, $btn.outerHeight() + 5);
            }

            // Hide the custom popup.
            function hidePopup() {
                editor.popups.hide('customPlugin.popup');
            }

            // Methods visible outside the plugin.
            return {
                showPopup: showPopup,
                hidePopup: hidePopup
            };
        };
        // Define an icon and command for the button that opens the custom popup.
        $.FroalaEditor.DefineIcon('moreIcon', { NAME: 'angle-down', SVG_KEY: 'angle-down' });

        $.FroalaEditor.RegisterCommand('moreButtons', {
            title: 'More Options',
            icon: 'moreIcon',
            focus: false,
            undo: false,
            plugin: 'customPlugin',
            callback: function (cmd, val) {
                this.customPlugin.showPopup();
            }
        });
    }

    focusEditor() {
        if (this.config.readonly) {
            return;
        }
        this.mode = TileMode.WRITE;
    }

    setConfig(config: TamDashboardRichTextTileConfiguration): boolean {
        // modify reason, same as pie chart
        this.config = config;
        this._init();
        return true;
    }

    onChange(event) {
        this.config.onChange(event);
    }

    onEditorInit(controls) {
        controls.initialize();
        this._editor = controls.getEditor();
    }

    private _init() {
        this._destroySubscriptions.push(
            this.config.actionSubject$.pipe(
                filter((action: any) => action && action.id === this.config.id),
            ).subscribe(action => this._onSubscribeActions(action)),
            this._afterViewFeedback$.subscribe((payload) => {
                if (payload === TamDashboardEvents.TILE_AFTER_VIEW_INIT) {
                    this.config.feedbackSubject$.next({
                        type: TamDashboardEvents.TILE_AFTER_VIEW_INIT,
                        id: this.config.id
                    });
                }
            })
        );
    }

    private _onSubscribeActions(action) {
        if (action.type === TamDashboardActions.SET_TILE_DATA) {
            //  add settime out otherwise it won't work while editing.and by tested,300ms is currently the best fit
            setTimeout(() => {
                this.data = action.payload;
                if (!this.data) {
                    this.data = {};
                }
                if (!this.data.html) {
                    this.data.html = '';
                }

                this.config.feedbackSubject$.next({
                    type: TamDashboardEvents.TILE_LOADED_DATA,
                    id: this.config.id
                });
            }, 300);
        } else if (action.type === TamDashboardActions.CHANGE_MODE) {
            this.mode = action.payload;
        }
    }
}
